import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCodeComponent, exclusionComponentDialog } from './custom-code.component';
import { CustomCodeRoutingModule } from './custom-code-routing.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthenticationComponent } from './authentication/authentication.component';
import { AuthenticationNativeComponent } from './authentication-native/authentication-native.component';
import { AuthenticationUrlComponent } from './auth-url/auth-url.component';
import { deactivateAuthenticationDialog } from './authentication-native/authentication-native.component';
import { CustomCodeListComponent } from './customCode-list/customCode-list.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgOtpInputModule } from 'ng-otp-input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCardModule } from '@angular/material/card';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ClipboardModule } from 'ngx-clipboard';
// import { TooltipModule } from 'ng2-tooltip-directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { MatRippleModule } from '@angular/material/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LibModule } from '../lib/lib.module';
import { MatSliderModule } from '@angular/material/slider';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CroppieModule } from 'angular-croppie-module';
import { LyImageCropperModule } from '@alyle/ui/image-cropper';
import { LyButtonModule } from '@alyle/ui/button';
import { LyIconModule } from '@alyle/ui/icon';
import { LySliderModule } from '@alyle/ui/slider';
@NgModule({
  declarations: [
    CustomCodeComponent,
    exclusionComponentDialog,
    AuthenticationComponent,
    AuthenticationNativeComponent,
    AuthenticationUrlComponent,
    deactivateAuthenticationDialog,
    CustomCodeListComponent
  ],
  imports: [
    CommonModule,
    CustomCodeRoutingModule,
    MatStepperModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatIconModule,
    MatInputModule,
    MatSlideToggleModule,
    NgOtpInputModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatSelectModule,
    MatRadioModule,
    MatCheckboxModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    ClipboardModule,
    TooltipModule,
    MatRippleModule,
    NgbModule,
    LibModule,
    MatSliderModule,
    ImageCropperModule,
    CroppieModule,
    LyImageCropperModule,
    LyButtonModule,
    LyIconModule,
    LySliderModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]

})
export class CustomCodeModule { }
